export default (url) => {
  const a = document.createElement('a');
  a.href = url;
  return {
    protocol: a.protocol,
    host: a.hostname,
    port: a.port || ((a.protocol === 'https:' || a.protocol === 'wss:') ? 443 : 80),
    path: a.pathname,
    secure: a.port === 443 || a.protocol === 'https:' || a.protocol === 'wss:'
  };
};
